/**
 * if the product has a trial and a setup fee, it's a paid trial
 * if the product has a trial and no setup fee, it's a free trial
 * if the product does not have a trial, it's false
 */
export function getTrial(product) {
  if (product.trialPeriodDays) {
    return product.setupFee ? 'paid' : 'free';
  }

  return '';
}
